import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import { absoluteUrl } from '../../utils/url';
import { updateMetaData } from '../../actions/metaDataActions';
import { setFullHeight } from '../../actions/uiActions';
import { playerStart } from '../../actions/playerActions';
import { RedirectAs404 } from '../Error404';
import Player from '../Player';


class MediaTitle extends Component {
  constructor (props) {
    super(props);
    this.state = {
      playerUid: null,
      fullSize: props.displayOptions && props.displayOptions.layout === 'fullwidth',
    };
    // this.handlePlayerInit = this.handlePlayerInit.bind(this);
    this.setMetaData = this.setMetaData.bind(this);
  }

  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { actions } = this.props;
    const { fullSize } = this.state;
    actions.setFullHeight(fullSize);
  }

  componentDidMount () {
    this.setMetaData();
  }

  componentWillUnmount () {
    this.setMetaData(true);
  }

  // handlePlayerInit (uid) {
  //   const { actions, autoplay } = this.props;
  //   this.setState({ playerUid: uid }, () => {
  //     if (autoplay) {
  //       actions.playerStart(uid);
  //     }
  //   });
  // }

  setMetaData (reset = false) {
    const { actions, name, shortDescription } = this.props;
    const url = absoluteUrl(window.location.pathname);
    actions.updateMetaData({
      page: reset ? {} : {
        url,
        description: shortDescription,
        title: name,
      },
    });
  }

  renderMedia () {
    const { slug, metadata } = this.props;
    const { fullSize } = this.state;
    const videoSource = metadata ? (metadata.sourceUrl || metadata.sourceId) : null;
    if (videoSource) {
      return (
        <Player
          fullSize={fullSize}
          video={videoSource}
          slug={slug}
          // onInit={this.handlePlayerInit}
        />
      );
    }
    // TODO: handle other media types
  }

  render () {
    const { match, name, longDescription, displayOptions } = this.props;
    const { fullSize } = this.state;
    const wrapClasses = classNames({
      'title-wrapper': true,
      'media-fullwidth': fullSize,
    });
    const showName = get(displayOptions, 'showName', true);
    const showDescription = get(displayOptions, 'showDescription', true);

    return (
      <Switch>
        <Route exact path={match.url} render={props => {
          return (
            <div className={wrapClasses}>
              {fullSize
                ? this.renderMedia()
                : (
                  <div className="title-alt-container">
                    {showName ? (
                      <header>
                        <h4 className="heading-alt text-uppercase mb-2">{name}</h4>
                      </header>
                    ) : null}
                    {this.renderMedia()}
                    {longDescription && showDescription ? (
                      <div className="my-3">
                        <div className="body-copy" dangerouslySetInnerHTML={{ __html: longDescription }} />
                      </div>
                    ) : null}
                  </div>
                )
              }
            </div>
          );
        }} />
        <Route component={RedirectAs404} />
      </Switch>
    );
  }
}

MediaTitle.propTypes = {
  uid: PropTypes.string.isRequired,
  name: PropTypes.string,
  slug: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
};

MediaTitle.defaultProps = {
  autoplay: true,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight, updateMetaData, playerStart }, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(MediaTitle));



// WEBPACK FOOTER //
// ./src/components/Title/MediaTitle.js